/* ============================================================
   SOLVEY · Weglot switcher — click/tap toggle (Weglot-bypass)
   ------------------------------------------------------------
   Probleem dat we hier oplossen:
   Weglot heeft een eigen click-handler op de `.wgcurrent` pill
   die in z'n NIET-HOVER mode wartaal-gedrag vertoont:
   - Klik 1 (vanuit "neutraal") zet `.closed` op de aside → niets verandert visueel
   - Klik 2 zet `.open` → dropdown verschijnt
   - Klik 3 zet weer `.closed` → dropdown weg
   Daardoor lijkt de eerste klik "niets te doen" en frustreert gebruikers.

   Onze fix: capture-phase click handler op `.wgcurrent` met
   `stopImmediatePropagation()` blokkeert Weglot's eigen handler
   volledig. Wij zetten zelf één-op-één een `.is-open` class op
   de closest container, met direct-toggle gedrag:
   - Klik 1 op pill → opent
   - Klik 2 op pill → sluit
   - Klik op andere taal-link → laat door (Weglot regelt switch)
   - Klik buiten container → sluit
   - Escape → sluit + focus terug
   - Scroll → sluit (gebruiker is duidelijk klaar)
   ============================================================ */
(function () {
  'use strict';

  var WG_SELECTOR = '.weglot-container, .country-selector';
  var TRIGGER_SELECTOR = '.wgcurrent';

  function setOpen(el, open) {
    el.classList.toggle('is-open', open);
    // Verwijder Weglot's eigen state-classes zodat ze niet conflicteren
    if (!open) {
      el.classList.remove('open');
      el.classList.remove('closed');
    }
    var cur = el.querySelector(TRIGGER_SELECTOR);
    if (cur) cur.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function attachToTrigger(trigger) {
    if (trigger.dataset.solveyClickInit === '1') return;
    trigger.dataset.solveyClickInit = '1';

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    // Capture-phase click — vuurt VÓÓR Weglot's eigen bubble handler.
    // stopImmediatePropagation() blokkeert alle volgende handlers (zowel
    // capture als bubble), inclusief Weglot's switcher-toggle logica.
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var container = trigger.closest(WG_SELECTOR);
      if (!container) return;
      setOpen(container, !container.classList.contains('is-open'));
    }, true); // capture: true

    // Keyboard support (Enter/Space)
    trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      var container = trigger.closest(WG_SELECTOR);
      if (!container) return;
      setOpen(container, !container.classList.contains('is-open'));
    });
  }

  function init() {
    var triggers = document.querySelectorAll(TRIGGER_SELECTOR);
    if (!triggers.length) return false;
    triggers.forEach(attachToTrigger);
    return true;
  }

  // Sluit alle open switchers bij pointerdown of click BUITEN de switcher.
  // Capture-phase + pointerdown vuurt voordat andere scripts dingen kunnen
  // suppressen, en dekt zowel mouse als touch.
  function closeOnOutside(e) {
    document.querySelectorAll(WG_SELECTOR).forEach(function (el) {
      if (!el.classList.contains('is-open')) return;
      if (!el.contains(e.target)) setOpen(el, false);
    });
  }
  document.addEventListener('pointerdown', closeOnOutside, true);
  document.addEventListener('click', closeOnOutside, true);

  // Scroll → sluit
  window.addEventListener('scroll', function () {
    document.querySelectorAll(WG_SELECTOR).forEach(function (el) {
      if (el.classList.contains('is-open')) setOpen(el, false);
    });
  }, { passive: true });

  // Escape → sluit + focus terug
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(WG_SELECTOR).forEach(function (el) {
      if (!el.classList.contains('is-open')) return;
      setOpen(el, false);
      var cur = el.querySelector(TRIGGER_SELECTOR);
      if (cur && typeof cur.focus === 'function') cur.focus();
    });
  });

  // Weglot kan switcher pas later renderen — observer + retry
  if (!init()) {
    var obs = new MutationObserver(function () {
      if (init()) obs.disconnect();
    });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
